// pages/auth/forgot-password.js

import { useState, useEffect } from 'react';
import axios from 'axios';
import Head from 'next/head';
import Link from 'next/link';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (countdown > 0) return;

    setError('');
    setSuccess('');

    try {
      // console.log('Submitting forgot password request');
      const response = await axios.post('/api/auth/forgot-password', { email });
      // console.log('Forgot password response:', response.data);
      setSuccess('Password reset email sent. Please check your inbox.');
      setCountdown(60);
    } catch (err) {
      // console.error('Error in forgot password request:', err);
      if (err.response) {
        // console.error('Error response:', err.response.data);
        setError(err.response.data.error || 'An error occurred. Please try again.');
      } else if (err.request) {
        // console.error('Error request:', err.request);
        setError('No response received from the server. Please try again.');
      } else {
        // console.error('Error message:', err.message);
        setError('An error occurred. Please try again.');
      }
    }
  };

  return (
    <>
      <Head>
        <title>Forgot Password - Sojot, Social Jot</title>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap" rel="stylesheet" />
      </Head>
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-100 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 font-inter">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h1 className="text-center text-5xl font-black text-gray-900 mb-2">
              <span className="bg-clip-text">
                Sojot
              </span>
            </h1>
            <h2 className="text-center text-3xl font-bold text-gray-900">
              Forgot Your Password?
            </h2>
          </div>
          {error && <p className="text-red-500 text-center">{error}</p>}
          {success && <p className="text-green-500 text-center">{success}</p>}
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <button
                type="submit"
                disabled={countdown > 0}
                className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                  countdown > 0 ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {countdown > 0 ? `Resend in ${countdown}s` : 'Reset Password'}
              </button>
            </div>
          </form>
          <div className="text-center">
            <Link href="/auth/login" className="font-medium text-blue-600 hover:text-blue-500">
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}